import React from 'react';
import './Styles.css';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { useNavigate } from 'react-router-dom';
import { teamPageReducerTypes } from '../../Reducer';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import SecondaryButton from '../../../../Elements/ids/Buttons/SecondaryButton';
import PrimaryButton from '../../../../Elements/ids/Buttons/PrimaryButton';
import { useTeamPageContext } from '../../TeamPage';

const TeamNotFound = ({ codePrefix }) => {
  const { teamPageDispatch } = useTeamPageContext();
  const navigate = useNavigate();

  return (
    <div className="teamPage-notFound-container">
      <ErrorMessage
        message={formatMessage(Messages.teamInfo_teamNotFound, {
          codePrefix: codePrefix,
        })}
      />
      <div className="teamPage-notFound-buttons">
        <SecondaryButton
          text={formatMessage(Messages.common_goToSearch)}
          onClickEvent={() => {
            navigate('/');
          }}
        />
        <PrimaryButton
          text={formatMessage(Messages.teamInfo_createNewTeamButton)}
          onClickEvent={() => {
            teamPageDispatch({
              type: teamPageReducerTypes.notFoundTeamResult,
              payload: {},
            });
            navigate('/team/add');
          }}
        />
      </div>
    </div>
  );
};

export default TeamNotFound;
